/**
 * Preferência "Ao vivo" da aba Erros (pedido 09/09: "coloque um pooling de 5
 * segundos na tela de erro tb pfv e um toggle botton para habilitar ou
 * desabilitar ele") — leitura/escrita PURAS no localStorage, isoladas do JSX.
 *
 * Duas decisões que este módulo carrega:
 *
 * 1. DEFAULT DESLIGADO. A consulta de auditoria varre trilha time-series
 *    volumosa no Mongo (janela default de 7 dias) e ainda agrega o top-10 por
 *    tipo e por bot na MESMA passada — ligar por padrão para todo mundo que
 *    abrisse a aba geraria carga contínua sem ninguém ter pedido. Quem quer
 *    acompanhar liga; a preferência é dele, não do sistema. Por isso qualquer
 *    valor que não seja exatamente o literal de "ligado" (ausente, corrompido,
 *    de uma versão futura) cai em DESLIGADO — o fallback nunca liga sozinho.
 *
 * 2. Storage é OPCIONAL, não requisito. Navegador em modo privado, cookies de
 *    terceiros bloqueados ou quota estourada fazem `localStorage` lançar já no
 *    getter do `window` — a tela precisa continuar funcionando (com o default),
 *    nunca quebrar por causa de uma conveniência de conforto. Daí o try/catch em
 *    volta de TODO acesso, inclusive o do próprio `window.localStorage`.
 */

/** Chave namespaced por página.aba.preferência — não colide com o resto do admin. */
export const CHAVE_AO_VIVO = 'orq.erros.aoVivo';

/** Intervalo do polling quando ligado (ms) — o "5 segundos" do pedido. */
export const INTERVALO_AO_VIVO_MS = 5000;

const LIGADO = '1';
const DESLIGADO = '0';

/**
 * Lê a preferência salva. Storage indisponível, chave ausente ou conteúdo
 * inesperado → `false` (desligado), sempre sem lançar.
 */
export function lerPreferenciaAoVivo(storage?: Storage | null): boolean {
  try {
    const alvo = storage ?? window.localStorage;
    return alvo?.getItem(CHAVE_AO_VIVO) === LIGADO;
  } catch {
    return false;
  }
}

/**
 * Grava a preferência. Falha de escrita (quota, modo privado) é ENGOLIDA de
 * propósito: perder a persistência é aceitável, derrubar a aba não é.
 */
export function salvarPreferenciaAoVivo(ligado: boolean, storage?: Storage | null): void {
  try {
    const alvo = storage ?? window.localStorage;
    alvo?.setItem(CHAVE_AO_VIVO, ligado ? LIGADO : DESLIGADO);
  } catch {
    // silêncio proposital — ver docstring
  }
}

/**
 * `refetchInterval` efetivo da query da auditoria: o intervalo quando ligado,
 * `false` (sem polling) quando desligado. Separado do componente para o teste
 * poder afirmar o valor que vai para o TanStack sem espiar o DOM.
 */
export function intervaloDeRefetch(ligado: boolean): number | false {
  return ligado ? INTERVALO_AO_VIVO_MS : false;
}
